export interface SalesOrderStatusItem {
  id: string;
  orderStatus: string;
  user: string;
  processedDate: Date;
}
